export default __webpack_public_path__ + "static/media/pictogramBeaconProcess64.a9e88f5b.svg";